module.exports = __webpack_public_path__ + "static/media/varal-2@8b75porc.2a4b6d52.png";